module.exports = __webpack_public_path__ + "img/spacemacs.d8b19c12.png";